// extracted by mini-css-extract-plugin
export default {"stickyBtnWrap":"Style_stickyBtnWrap__vI1tx","upperWrap":"Style_upperWrap__MkOzH","upperNum":"Style_upperNum__-QypV","btnWrap":"Style_btnWrap__MuWMs","edit":"Style_edit__r8MwC"};